import React, { Component } from 'react';
import Validate from '../components/Validate';
import ContactPersons from '../components/ContactPersons'
import CustomerInfo from '../components/CustomerInfo'
import GeneralPractitioner from '../components/GeneralPractitioner';
import EditCustomer from './EditCustomer';
import Protocol from '../components/Protocol'
import Config from '../Config'
import Spinner from '../components/Spinner';

import './css/information.css'


class Information extends Component {
    constructor(props) {
        super(props);

        var bp = props.current.serviceCall.businessPartner;
        var keySafeCode = props.changes.state.keySafeCode === null ? bp.keySafeCode : props.changes.state.keySafeCode;
        var iban = props.changes.state.iban === null ? bp.iban : props.changes.state.iban;

        this.state = {
            iban: iban,
            keySafeCode: keySafeCode,
            isFirstSave: props.current.isFirstSave,
            enableChangeKeySafeCode: props.current.isFirstSave,
            enableChangeIban: props.current.isFirstSave && !Validate.IsValidIban(bp.iban),
            loadingPartnerInfo:false,
            partnerInfo: null,
            partnerEquipmentInfo: null
        };

     

        

    }
    componentDidMount() {
        var bp = this.props.current.serviceCall.businessPartner;
        // init the protocol
        Protocol.Init(bp.emergencyCenter.code, bp.reportingCenterCode1, bp.reportingCenterCode2, p => {
            this.setState({ protocol: p });
        });

        // init information for partner
        if (bp.cardForeignName !== "") {
            this.loadPartnerInfo(bp.cardForeignName);
        }
    }

    loadPartnerInfo(cardCode) {
        if (cardCode===null) return;
        if (cardCode[0]!=="D") return;
        if (!(cardCode.substring(1)>0)) return;

        this.setState({loadingPartnerInfo:true});
        const url = Config.DigibonServiceBase + "businessPartners/" + cardCode;
        fetch(url, Config.GetBearer())
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                console.log(json);
                if (json.status===500) {
                    // some error
                    this.setState({loadingPartnerInfo:false});
                } else {
                    this.setState({ loadingPartnerInfo:false, partnerInfo: json.result });
                    this.loadPartnerEquipment(cardCode);
                }
            }
            ).catch((error) => {
                this.setState({loadingPartnerInfo:false});
                console.log(error);
            })

        
    }
    loadPartnerEquipment(cardCode) {
        const url = Config.DigibonServiceBase + "businessPartners/" + cardCode + "/equipmentcards";
        fetch(url, Config.GetBearer())
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                this.setState({ partnerEquipmentInfo: json.result });
            }
            ).catch((error) => {
                console.log(error);
            })
    }


    handleChangeIban = (e) => {
        this.setState({ iban: e.target.value });
        this.props.changes.SetIban(e.target.value);

    };

    handleChangeKeySafeCode = (e) => {
        this.setState({ keySafeCode: e.target.value });
        this.props.changes.SetKeySafeCode(e.target.value);
    };

    toUpper(e) {
        e.target.value = e.target.value.toUpperCase()
    }

    handleCheckbox(evt) {
        const name = evt.target.name;
        const value = evt.target.checked;
        this.setState({ [name]: value });
        this.props.changes.Set(name, value);  // save to the parent object
    }
    editCustomer() {
        this.setState({ mode: "editCustomer" });
    }
    closeDetails() {
        this.setState({ mode: "" });
    }
    saveCustomer() {
        this.closeDetails();
    }

    render() {
        const bon = this.props.current;
        const bp = bon.serviceCall.businessPartner;



        return <React.Fragment>
            <div className="row">
                {this.state.mode === "editCustomer" &&
                    <div>
                        <div className="edit-back"></div>

                        <div className="edit-front">
                            <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.closeDetails.bind(this)}>
                                <i className="fa-sharp fa-solid fa-xmark"></i>
                            </button>

                            <EditCustomer bp={bp} changes={this.props.changes} close={this.closeDetails.bind(this)}></EditCustomer>

                        </div>

                    </div>
                }


                <div className="col-md mb-2">
                    <div><b>Algemeen:</b></div>

                    <div>Opdracht via: {bp.clientProvider.name}</div>
                    <div>Zorgpartner: {bp.healthPartner.name}</div>
                    <div>Meldcentrale: {bp.emergencyCenter.name}</div>
                    <div>Meldbank code: {bp.reportingCenterCode1} {bp.reportingCenterCode2}

                        {this.state.protocol &&
                            <span className="ms-4">Protocol: {this.state.protocol}</span>}

                    </div>
                    
                    {(this.state.enableChangeKeySafeCode) &&            // only show code for first save (not when re-opening old bon)
                        <div className="row form-control-group mb-2">
                            <div className="col-md-3">Sleutelkluiscode</div>
                            <div className="col">
                                {this.state.enableChangeKeySafeCode && <React.Fragment>
                                    <input className="form-control" value={this.state.keySafeCode} maxLength="8" onChange={this.handleChangeKeySafeCode} onInput={this.toUpper}></input>
                                    <Validate value={this.state.keySafeCode} type="code"></Validate>
                                </React.Fragment>
                                }

                                {!this.state.enableChangeKeySafeCode && bp.keySafeCode &&
                                    <div>{bp.keySafeCode}</div>
                                }

                            </div>
                            <div className="col">
                                <i className="fa-solid fa-circle-info"></i> Kluis niet door CSI geleverd
                            </div>

                        </div>
                    }


                    {(this.state.enableChangeIban || this.state.iban) &&
                        <div className="row form-control-group mb-2">
                            <div className="col-md-3">IBAN</div>
                            <div className="col">
                                {this.state.enableChangeIban && <React.Fragment>
                                    <input className="form-control" value={this.state.iban} maxLength="18" onChange={this.handleChangeIban} onInput={this.toUpper}></input>
                                    <Validate value={this.state.iban} type="iban"></Validate>
                                </React.Fragment>
                                }
                                {!this.state.enableChangeIban && <React.Fragment>
                                    {this.state.iban}
                                </React.Fragment>
                                }
                            </div>

                        </div>
                    }
                </div>
                <div className="col-md">

                    <div className="row">
                        <div className="col">
                            {this.state.isFirstSave &&
                                <div onClick={this.editCustomer.bind(this)}><b>Bezoekadres:</b> <i className="fas fa-edit ms-4 clickable"></i> </div>
                            }
                            {!this.state.isFirstSave &&
                                <div><b>Bezoekadres:</b></div>
                            }


                            <CustomerInfo bp={bp} changes={this.props.changes}></CustomerInfo>

                        </div>
                        <div className="col">
                            <GeneralPractitioner data={bp.generalPractitioner}></GeneralPractitioner>
                        </div>
                    </div>

                    <b>Contactpersonen:</b>
                    <div className="row">
                        <ContactPersons bon={bon} enableEdit={this.state.isFirstSave} changes={this.props.changes}></ContactPersons>
                    </div>

                    {bp.cardForeignName && <>
                        <b>Partner:</b>
                        <div className="row">
                            <div className="col">

                                {this.state.loadingPartnerInfo === null &&
                                    <div><Spinner></Spinner>  Loading {bp.cardForeignName}</div>
                                }
                                {this.state.partnerInfo !== null &&
                                    <>
                                        {!this.state.partnerInfo.active && <div className="text-danger">Partner heeft geen actieve status</div>}
                                        <div >{this.state.partnerInfo.shipToDef} ({bp.cardForeignName})</div>
                                        <div >Status: {this.state.partnerInfo.status} </div>
                                        {this.state.partnerInfo.productCountersRent.handzenders > 0 && <div>Handzenders: {this.state.partnerInfo.productCountersRent.handzenders}</div>}
                                        {this.state.partnerInfo.productCountersRent.collierzenders > 0 && <div>Collierzenders: {this.state.partnerInfo.productCountersRent.collierzenders}</div>}
                                        {this.state.partnerInfo.productCountersRent.rookmelder > 0 && <div>Rookmelders: {this.state.partnerInfo.productCountersRent.rookmelder}</div>}


                                    </>
                                }
                                { this.state.partnerInfo === null && !this.state.loadingPartnerInfo && 
                                    <div>
                                        {bp.cardForeignName}
                                    </div>
                                }
                            </div>
                            {this.state.partnerEquipmentInfo != null &&
                                <div className="col">
                                            { this.state.partnerEquipmentInfo.map((item, index) => {
                                                return <div key={index}><div className="row" >
                                                        <div className="col-md-2">{item.number}</div>
                                                        <div className="col">{item.item.name} ({item.item.code})</div>
                                                    </div></div>
                                            })
                                            }
                                    
                                </div>
                            }
                        </div>
                    </>
                    }


                </div>
            </div>
            {false && !this.props.changes.state.createNewServiceCall &&
                <div className="mt-4">
                    <label><input type="checkbox" name="cancelServiceCall" checked={this.props.changes.state.cancelServiceCall} onChange={this.handleCheckbox.bind(this)}></input> opdracht annuleren</label>
                    {
                        this.props.changes.state.cancelServiceCall && <div className="text-danger">
                            <i className="fa-solid fa-circle-info"></i>  Deze bon zal worden geannuleerd. Geef bij Acties aan welke kosten in rekening gebracht worden. Klant status blijft ongewijzigd.
                        </div>
                    }
                </div>
            }

        </React.Fragment>


    }
}


export default Information;